module.exports = __webpack_public_path__ + "img/465128-2.54b0383e.png";